import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-wrap flex-1 md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex-shrink-0 flex lg:flex-row flex-col mx-auto pr-8" }
const _hoisted_3 = { class: "max-w-lg md:w-56 lg:max-w-xs" }
const _hoisted_4 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_5 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "flex flex-col md:flex-row mx-auto md:mr-auto" }
const _hoisted_8 = { class: "py-6" }
const _hoisted_9 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_10 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import DateSelector from "@/components/tools/DateTimeSelector.vue";
import CommissionPayoutFilterDialog from "@/components/dialogs/CommissionPayoutFilterDialog.vue";
import { formatNumber, translate } from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'CommissionPayoutV2',
  setup(__props) {

dayjs.extend(localizedFormat);
const SearchIcon = require("@heroicons/vue/solid/SearchIcon");
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref(false);
const columns = ref([
  {
    label: translate("messages.commissionPayout.accountName"),
    field: "account_name",
    sort: true,
    isSorted: false,
    format: (data: any) => (data.account_name ? data.account_name : "-"),
  },
  {
    label: translate("messages.commissionPayout.phoneNumber"),
    field: "user_phone",
    align: "center",
    format: (data: any) =>
      data.affiliate.user_phone
        ? data.affiliate.user_phone.replace("+66", "0")
        : "-",
  },
  {
    label: translate("messages.commissionPayout.amount"),
    field: "amount",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.total),
    class: (data: any) => {
      return Number(data.total) < 0
        ? "text-red-500"
        : "text-green-500";
    },
  },
  {
    label: translate("messages.commissionPayout.requested"),
    field: "created_at",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.created_at).locale("th").format("LLL"),
  },
  {
    label: translate("messages.commissionPayout.startDate"),
    field: "start_date",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.start_date).locale("th").format("LLL"),
  },
  {
    label: translate("messages.commissionPayout.endDate"),
    field: "end_date",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.end_date).locale("th").format("LLL"),
  },
  {
    label: translate("messages.commissionPayout.status"),
    field: "status",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => (data.status ? data.status : "-"),
    class: (data: any) =>
      data.status == "UNPAID"
        ? "inline-block text-xs py-1 px-2 rounded-lg bg-red-500 text-white"
        : "inline-block text-xs py-1 px-2 rounded-lg bg-green-500 text-white",
  },
]);
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: undefined,
  sort: [["id", "DESC"]],
});
const filterForm = ref({
  mobile: null,
  date_requested: null,
  from: null,
  to: null,
});

const filterModal = (data = { flag: 0, chanel: null }) => {
  advanceFilterModal.value = !advanceFilterModal.value;
  if (data.flag == 1) {
    pageConfig.value.page = 1;
    // filterForm.value.channel = data.chanel
    fetchPageData();
  }
};
const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  if (attName === "Amount") attName = "total";
  if (attName === "Requested Date") attName = "created_at";
  sort[0] = [
    attName.toLowerCase().replace(" ", "_"),
    mode === "DESC" ? "ASC" : "DESC",
  ];

  fetchPageData();
};
const fetchPageData = async () => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort, search } = pageConfig.value;
  const { mobile, date_requested, from, to } = filterForm.value;

  const payload: any = {
    operator_id: store.state.selectedOperator.operatorId,
    type: "TURN_OVER",
    offset: page * rowsPerPage - rowsPerPage,
    limit: rowsPerPage,
    search: search,
    phone_number:
      mobile && (mobile as string)[0] == "0"
        ? (mobile as string).replace("0", "+66")
        : null,
    date: date_requested,
    start_date: dayjs(from).format("YYYY-MM-DD") || null,
    end_date: dayjs(to).format("YYYY-MM-DD") || null,
    order_by: sort,
  };
  if (!from) delete payload.start_date;
  if (!to) delete payload.end_date;
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/payout/customer/downline/pagination-nocount`;
  const rows = await axios
    .post(url, payload)
    .then(({ data }) => data.data);

  // if(!rows || rows.length == 0){
  //   if(pageConfig.value.page == 1){
  //     dataRows.value = []
  //     isLoaded.value = true;
  //     return
  //   }
  //   pageConfig.value.page = page - 1
  //   return
  // }

  const count = rows.length

  pageConfig.value.dataLength = rows.length;

  dataRows.value = rows;

  pageConfig.value = {
    ...pageConfig.value,
    count,
    pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};
const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData();
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);
watch(
  () => pageConfig.value.search,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Navbar, {
        title: _ctx.$t('messages.commissionPayout.commissionPayout')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(SearchIcon), {
                  class: "h-5 w-5",
                  "aria-hidden": "true"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
                maxlength: "10",
                class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
                placeholder: _ctx.$t('messages.commissionPayout.search'),
                type: "search",
                name: "search"
              }, null, 8, _hoisted_6), [
                [_vModelText, pageConfig.value.search]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(DateSelector, { onSearch: onSearch })
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (filterModal())),
            class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
          }, [
            _createVNode(_component_font_awesome_icon, {
              class: "text-white mr-2",
              icon: ['far', 'filter'],
              transform: ""
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.commissionPayout.advanceFilter")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(DataTable, {
              columns: columns.value,
              data: dataRows.value,
              onSort: doSort,
              isLoaded: isLoaded.value
            }, null, 8, ["columns", "data", "isLoaded"]),
            _createVNode(Pagination, {
              config: pageConfig.value,
              "onUpdate:config": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig).value = $event))
            }, null, 8, ["config"])
          ])
        ])
      ])
    ]),
    _createVNode(CommissionPayoutFilterDialog, {
      class: "z-10",
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[4] || (_cache[4] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"])
  ], 64))
}
}

})